import React from "react";
import "./index.css";
import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import Button from "@material-ui/core/Button";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import { SwipeableDrawer } from "@material-ui/core";
import ReviewDrawerContent from "../Branches/ReviewDrawerContent";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { connect } from "react-redux";
import ActionButton from "../ActionButton";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Feedback({ order, language, history, settings }) {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);

  return (
    <div
      className="border w-100 row m-0"
      style={{ backgroundColor: "white", minHeight: 70 }}
    >
      {drawerOpen && (
        <SwipeableDrawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => {
            setDrawerOpen(false);
          }}
          PaperProps={{
            style: { minHeight: 100, height: "auto" },
            className: "text-center",
          }}
          onBackdropClick={() => setDrawerOpen(false)}
          onOpen={() => {}}
        >
          <ReviewDrawerContent
            closeDrawer={() => setDrawerOpen(false)}
            trackingCode={order.tracking_id}
            onSendSuccess={() => setAlertOpen(true)}
          />
        </SwipeableDrawer>
      )}

      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={() => setAlertOpen(false)}
        classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
      >
        <Alert onClose={() => setAlertOpen(false)} severity="success">
          {language == "english"
            ? "Your feedback has been sent successfully!"
            : "تم ارسال التقييم بنجاح!"}
        </Alert>
      </Snackbar>

      <div className="col-2" style={{ position: "relative" }}>
        <SentimentVerySatisfiedIcon
          className="center-x-y"
          style={{ fontSize: 32, color: "#999" }}
        />
      </div>
      <div
        className={"col-10 py-3 ".concat(
          language == "english" ? "text-left" : "text-right"
        )}
      >
        <p className="mb-1 bold">
          {language == "english"
            ? "Enjoyed your experience? Let us know!"
            : "استمتعت بالتجربة؟ قم بإرسال تقييمك"}
        </p>

        <Button
          color="primary"
          //onClick={() => this.toggleDrawer(true)}
          endIcon={language == "english" && <ThumbUpIcon />}
          startIcon={
            language == "arabic" && (
              <ThumbUpIcon style={{ marginLeft: 8, marginRight: 0 }} />
            )
          }
          style={{ textTransform: "none", padding: 0 }}
          onClick={() =>
            settings.enable_product_feedback &&
            settings.enable_product_feedback_staff
              ? history.push({
                  pathname: `/track/order/${order.tracking_id}/review`,
                  state: {
                    order: order,
                  },
                })
              : setDrawerOpen(true)
          }
        >
          <span>
            {language == "english" ? "Rate your experience" : "قيم التجربة"}
          </span>
        </Button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
  };
};
export default connect(mapStateToProps)(Feedback);
